<template>
  <div class="container">
    <p id="titleTop">
      视知觉能力测试<span id="titleBottom">&nbsp;---&nbsp;{{ title }}</span>
    </p>
    <!-- <p id="titleTop">第二部分&nbsp;&nbsp;视知觉能力测试</p> -->
    <!-- <p id="titleBottom">{{title}}</p> -->
    <div id="progressContainer">
      <p v-show="!$store.state.global.isTest">{{ pw + "%" }}</p>
      <p v-show="$store.state.global.isTest">练习中</p>
      <div id="progressContent" :style="`width:${pw}%`"></div>
    </div>
    <img id="bgImg" v-show="isKuang" src="../../assets/red_bg.png" alt="" />
    <div id="imgContainer">
      <img
        id="img"
        width="900"
        v-show="isImg"
        @load="loadImg"
        :src="imgUrl"
        alt=""
      />
    </div>
    <div v-show="isAnwser" id="btnContainer">
      <div id="btnLeft" @click="selectLeft">
        <div></div>
        <span>{{ btnLeftSpan }}</span>
        <img :src="btnLeftImg" alt="" />
      </div>
      <div id="btnRight" @click="selectRight">
        <div></div>
        <span>{{ btnRightSpan }}</span>
        <img :src="btnRightImg" alt="" />
      </div>
    </div>
    <img v-show="tipImgBol" id="tipImg" :src="tipImgUrl" alt="" />
    <audio id="zhunqueAudio" src="../../assets/sound/zhunque.mp3"></audio>
    <audio id="cuowuAudio" src="../../assets/sound/cuowu.mp3"></audio>
  </div>
</template>

<script>
export default {
  name: "CommonTraining",
  data() {
    return {
      //展示的图片路劲
      imgUrl: "",
      title: "",
      //底部操作按钮北京
      btnLeftImg: "",
      btnRightImg: "",
      btnLeftSpan: "",
      btnRightSpan: "",
      //展示的图片宽
      imgWidth: null,
      //进度条长度
      pw: 0,
      //是否展示红框
      isKuang: false,
      //是否展示训练图片
      isImg: false,
      //每一类测试的图片数量
      totalImgNum: null,
      //每回合展示图片数量
      imgNum: null,
      //当前展示到第几个图片
      currentImgNum: null,
      //图片难度
      imgLv1: null,
      imgLv2: null,
      //是否可以答题
      isAnwser: false,
      //图片是否旋转
      isRotate: false,
      //判断答题是否正确
      isCorrect: null,
      tipImgUrl: "",
      tipImgBol: false,
      //判断图片是否加载超时
      timer: null,
    };
  },
  methods: {
    onPlayAudio(bol) {
      let a;
      // if(bol){
      //     a=document.getElementById('zhunqueAudio')
      // }
      // else{
      //     a=document.getElementById('cuowuAudio')
      // }
      a = document.getElementById("zhunqueAudio");
      a.play();
    },
    onSubmit() {
      let data = this.getData(this.$store.state.global.itemNum);
      //提交信息
      return new Promise((resolve, reject) => {
        this.$axios({
          url:
            this.$store.state.global.padUrl +
            "/visualplatpad/detector-report/save",
          method: "post",
          data: {
            globalId: this.$store.state.global.globalId,
            testType: this.$store.state.global.itemNum + 1,
            testResult: data,
          },
          headers: {
            Authorization: "Bearer " + this.$store.state.global.token,
            serverFlag: "",
            dsName: "",
            "content-type": "application/json",
          },
        }).then(
          (response) => {
            this.$store.state.global.isLoadingShow = false;
            if (!response.data.success) {
              this.$dialog
                .alert({
                  message:
                    "能力测试" +
                    (this.$store.state.global.itemNum + 1) +
                    "提交失败，请联系管理员",
                })
                .then(() => {
                  this.$router.push("/commonDescription");
                });
              return;
            }

            if (
              this.$store.state.global.isFirst &&
              this.$store.state.global.itemNum === 1
            ) {
              this.$store.state.global.itemNum = 3;
            } else if (
              this.$store.state.global.isFirst &&
              this.$store.state.global.itemNum === 3
            ) {
              this.$store.state.global.itemNum = 4;
            } else if (
              this.$store.state.global.isFirst &&
              this.$store.state.global.itemNum === 4
            ) {
              this.$router.push("/checkReport");
              return;
            } else {
              this.$store.state.global.itemNum++;
            }

            if (this.$store.state.global.itemNum === 7) {
              this.$router.push("/sejueDescription");
            } else {
              this.$router.push("/commonDescription");
            }
            resolve(response.data);
          },
          (error) => {
            this.$store.state.global.isLoadingShow = false;
            this.$dialog
              .alert({
                message:
                  "能力测试" +
                  (this.$store.state.global.itemNum + 1) +
                  "提交失败，请联系管理员",
              })
              .then(() => {
                this.$router.push("/commonDescription");
                reject(error);
              });
          }
        );
      });
    },
    getData(itemNum) {
      if (itemNum === 0) {
        return JSON.stringify({
          data: this.$store.state.guangshanruidu.progressData,
          point: this.$store.state.guangshanruidu.result,
        });
      }
      if (itemNum === 1) {
        return JSON.stringify({
          data: this.$store.state.jiezhipinlv.progressData,
          point: this.$store.state.jiezhipinlv.result,
        });
      }
      if (itemNum === 2) {
        return JSON.stringify({
          data: this.$store.state.youbiaoruidu.progressData,
          point: this.$store.state.youbiaoruidu.result,
        });
      }
      if (itemNum === 3) {
        return JSON.stringify({
          data: this.$store.state.wenliganzhi.progressData,
          point: this.$store.state.wenliganzhi.result,
        });
      }
      if (itemNum === 4) {
        return JSON.stringify({
          data: this.$store.state.wenliyundong.progressData,
          point: this.$store.state.wenliyundong.result,
        });
      }
      if (itemNum === 5) {
        return JSON.stringify({
          data: this.$store.state.guangshanyundong.progressData,
          point: this.$store.state.guangshanyundong.result,
        });
      }
      if (itemNum === 6) {
        return JSON.stringify({
          data: this.$store.state.zaoyinpaichu.progressData,
          point: this.$store.state.zaoyinpaichu.result,
        });
      }
    },
    onTip(str) {
      if (this.$store.state.global.isTest) {
        this.tipImgUrl = require("../../assets/" + str + ".png");
        this.tipImgBol = true;
        setTimeout(() => {
          this.tipImgBol = false;
        }, 500);
      }
    },
    loadImg() {
      if (this.$store.state.global.isTest && this.totalImgNum > 1) {
        return;
      }
      if (this.timer) {
        clearTimeout(this.timer);
      }
      this.showImg();
    },
    showImg() {
      this.currentImgNum = 0;
      this.isKuang = true;
      if (
        this.$store.state.global.itemNum === 0 || //光栅锐度能力测试
        this.$store.state.global.itemNum === 1 || //截止频率能力测试
        this.$store.state.global.itemNum === 2 || //游标锐度能力测试
        this.$store.state.global.itemNum === 6 //噪音排除能力测试
      ) {
        let timer = setInterval(() => {
          this.currentImgNum++;
          if (this.currentImgNum === this.imgNum) {
            this.isImg = true;
          } else if (this.currentImgNum - this.imgNum === 1) {
            this.isImg = false;
          } else if (this.currentImgNum - this.imgNum === 2) {
            this.isKuang = false;
            clearInterval(timer);
            //可以答题
            this.isAnwser = true;
          }
        }, 200);
      } else if (
        this.$store.state.global.itemNum === 3 //纹理感知能力测试
      ) {
        let img = document.getElementById("img");
        let timer = setInterval(() => {
          this.currentImgNum++;
          if (this.currentImgNum === 1) {
            this.isImg = true;
          } else if (this.currentImgNum === 2) {
            if (this.isRotate) {
              img.style.top = "0px";
            } else {
              img.style.left = -this.imgWidth + "px";
            }
          } else if (this.currentImgNum === 3) {
            if (this.isRotate) {
              img.style.top = -this.imgWidth + "px";
            } else {
              img.style.left = -this.imgWidth * 2 + "px";
            }
          } else if (this.currentImgNum === 4) {
            this.isImg = false;
          } else if (this.currentImgNum === 5) {
            this.isKuang = false;
            clearInterval(timer);
            //可以答题
            this.isAnwser = true;
          }
        }, 67);
      } else if (
        this.$store.state.global.itemNum === 4 || //纹理运动辨别能力测试
        this.$store.state.global.itemNum === 5 //光栅运动辨别能力测试
      ) {
        let img = document.getElementById("img");
        let timer = setInterval(() => {
          this.currentImgNum++;
          if (this.currentImgNum === 1) {
            this.isImg = true;
          } else if (this.currentImgNum === 2) {
            if (this.isRotate) {
              img.style.left = -this.imgWidth * 2 + "px";
            } else {
              img.style.left = -this.imgWidth + "px";
            }
          } else if (this.currentImgNum === 3) {
            if (this.isRotate) {
              img.style.left = -this.imgWidth + "px";
            } else {
              img.style.left = -this.imgWidth * 2 + "px";
            }
          } else if (this.currentImgNum === 4) {
            if (this.isRotate) {
              img.style.left = "0px";
            } else {
              img.style.left = -this.imgWidth * 3 + "px";
            }
          } else if (this.currentImgNum === 5) {
            this.isImg = false;
          } else if (this.currentImgNum === 6) {
            this.isKuang = false;
            clearInterval(timer);
            //可以答题
            this.isAnwser = true;
          }
        }, 50);
      }
    },
    loadImgFunc() {
      this.timer = setTimeout(() => {
        clearTimeout(this.timer);
        this.timer = null;
        this.$dialog
          .alert({
            message: "图片加载失败，请检查网络后重新测试!",
          })
          .then(() => {
            this.$router.push("/commonDescription");
          });
      }, 10000);
    },
    async getImgName() {
      if (this.$store.state.global.isLoadingShow) {
        return;
      }
      if (this.totalImgNum === 5 && this.$store.state.global.isTest) {
        // this.$dialog.alert({
        //     message:'测试已完成!',
        // }).then(()=>{
        //     this.$router.push('/commonDescription')
        // })
        this.$router.push("/commonDescription");
        return;
      }
      this.totalImgNum++;
      //判断是否旋转
      if (Math.random() < 0.45) {
        this.isRotate = true;
      } else {
        this.isRotate = false;
      }
      let img = document.getElementById("img");
      img.style.transform = "rotate(0deg)";
      img.style.transform = "rotateX(0deg)";
      img.style.left = "0px";
      img.style.top = "0px";
      img.style.width = this.imgWidth + "px";
      if (this.$store.state.global.itemNum === 0) {
        //光栅锐度能力测试
        if (this.isRotate) {
          img.style.transform = "rotate(90deg)";
        } else {
          img.style.transform = "rotate(0deg)";
        }
        //判断是否是测试状态
        if (this.$store.state.global.isTest) {
          if (this.imgUrl === "") {
            this.imgUrl =
              "https://oss.uflycloud.com/ufly_ai_vpft/SelfTest/GA/GA_8_00.png";
          } else {
            this.showImg();
          }
          return;
        }
        //判断是否结束
        if (this.totalImgNum > 10) {
          this.$store.state.global.isLoadingShow = true;
          //上传结果
          this.$store.state.guangshanruidu.result = Math.floor(
            (this.$store.state.guangshanruidu.progressData[
              this.$store.state.guangshanruidu.progressData.length - 1
            ][0] +
              this.$store.state.guangshanruidu.progressData[
                this.$store.state.guangshanruidu.progressData.length - 2
              ][0] +
              this.$store.state.guangshanruidu.progressData[
                this.$store.state.guangshanruidu.progressData.length - 3
              ][0]) /
              3
          );
          //提交数据
          await this.onSubmit();
          return;
        }
        this.pw = Math.floor((this.totalImgNum / 10) * 100);
        let str = "";
        str = this.imgLv1 > 9 ? this.imgLv1 : "0" + this.imgLv1;
        if (
          this.imgUrl ===
          "https://oss.uflycloud.com/ufly_ai_vpft/SelfTest/GA/GA_8_" +
            str +
            ".png"
        ) {
          this.showImg();
        } else {
          this.loadImgFunc();
          this.imgUrl =
            "https://oss.uflycloud.com/ufly_ai_vpft/SelfTest/GA/GA_8_" +
            str +
            ".png";
        }
      } else if (this.$store.state.global.itemNum === 1) {
        //截止频率能力测试
        if (this.isRotate) {
          img.style.transform = "rotate(90deg)";
        } else {
          img.style.transform = "rotate(0deg)";
        }
        //判断是否是测试状态
        if (this.$store.state.global.isTest) {
          if (this.imgUrl === "") {
            this.imgUrl =
              "https://oss.uflycloud.com/ufly_ai_vpft/SelfTest/CSF/CSF_0_00.png";
          } else {
            this.showImg();
          }
          return;
        }
        //判断是否结束
        if (this.totalImgNum > 20) {
          this.$store.state.global.isLoadingShow = true;
          //上传结果
          this.$store.state.jiezhipinlv.result = Math.floor(
            (this.$store.state.jiezhipinlv.progressData[
              this.$store.state.jiezhipinlv.progressData.length - 1
            ][1] +
              this.$store.state.jiezhipinlv.progressData[
                this.$store.state.jiezhipinlv.progressData.length - 2
              ][1] +
              this.$store.state.jiezhipinlv.progressData[
                this.$store.state.jiezhipinlv.progressData.length - 3
              ][1]) /
              3
          );
          //提交数据
          await this.onSubmit();
          return;
        }
        this.pw = Math.floor((this.totalImgNum / 20) * 100);
        let str = "";
        str = this.imgLv2 > 9 ? this.imgLv2 : "0" + this.imgLv2;
        if (
          this.imgUrl ===
          "https://oss.uflycloud.com/ufly_ai_vpft/SelfTest/CSF/CSF_" +
            this.imgLv1 +
            "_" +
            str +
            ".png"
        ) {
          this.showImg();
        } else {
          this.loadImgFunc();
          this.imgUrl =
            "https://oss.uflycloud.com/ufly_ai_vpft/SelfTest/CSF/CSF_" +
            this.imgLv1 +
            "_" +
            str +
            ".png";
        }
      } else if (this.$store.state.global.itemNum === 2) {
        //游标锐度能力测试
        if (this.isRotate) {
          img.style.transform = "rotateX(0deg)";
        } else {
          img.style.transform = "rotateX(180deg)";
        }
        //判断是否是测试状态
        if (this.$store.state.global.isTest) {
          if (this.imgUrl === "") {
            this.imgUrl =
              "https://oss.uflycloud.com/ufly_ai_vpft/SelfTest/VA/VA_0_0.png";
          } else {
            this.showImg();
          }
          return;
        }
        if (this.totalImgNum === 9) {
          this.$store.state.youbiaoruidu.result.push(
            Math.floor(
              (this.$store.state.youbiaoruidu.progressData[0][
                this.$store.state.youbiaoruidu.progressData[0].length - 1
              ][1] +
                this.$store.state.youbiaoruidu.progressData[0][
                  this.$store.state.youbiaoruidu.progressData[0].length - 2
                ][1]) /
                2
            )
          );
          this.imgLv1 = this.$store.state.youbiaoruidu.lvData[1];
          this.imgLv2 = 3;
        } else if (this.totalImgNum === 17) {
          this.$store.state.youbiaoruidu.result.push(
            Math.floor(
              (this.$store.state.youbiaoruidu.progressData[1][
                this.$store.state.youbiaoruidu.progressData[1].length - 1
              ][1] +
                this.$store.state.youbiaoruidu.progressData[1][
                  this.$store.state.youbiaoruidu.progressData[1].length - 2
                ][1]) /
                2
            )
          );
          this.imgLv1 = this.$store.state.youbiaoruidu.lvData[2];
          this.imgLv2 = 3;
        } else if (this.totalImgNum > 24) {
          this.$store.state.global.isLoadingShow = true;
          this.$store.state.youbiaoruidu.result.push(
            Math.floor(
              (this.$store.state.youbiaoruidu.progressData[2][
                this.$store.state.youbiaoruidu.progressData[2].length - 1
              ][1] +
                this.$store.state.youbiaoruidu.progressData[2][
                  this.$store.state.youbiaoruidu.progressData[2].length - 2
                ][1]) /
                2
            )
          );
          //跳转页面
          await this.onSubmit();
          return;
        }
        this.pw = Math.floor((this.totalImgNum / 24) * 100);
        if (
          this.imgUrl ===
          "https://oss.uflycloud.com/ufly_ai_vpft/SelfTest/VA/VA_" +
            this.imgLv1 +
            "_" +
            this.imgLv2 +
            ".png"
        ) {
          this.showImg();
        } else {
          this.loadImgFunc();
          this.imgUrl =
            "https://oss.uflycloud.com/ufly_ai_vpft/SelfTest/VA/VA_" +
            this.imgLv1 +
            "_" +
            this.imgLv2 +
            ".png";
        }
      }
      if (this.$store.state.global.itemNum === 3) {
        //纹理感知能力测试
        img.style.width = this.imgWidth * 3 + "px";
        if (this.isRotate) {
          img.style.transform = "rotate(90deg)";
          img.style.left = -this.imgWidth + "px";
          img.style.top = this.imgWidth + "px";
        } else {
          img.style.transform = "rotate(0deg)";
        }
        //判断是否是测试状态
        if (this.$store.state.global.isTest) {
          if (this.imgUrl === "") {
            this.imgUrl =
              "https://oss.uflycloud.com/ufly_ai_vpft/SelfTest/CS2nd/CS2nd_3_00.png";
          } else {
            this.showImg();
          }
          return;
        }
        //判断是否结束
        if (this.totalImgNum > 20) {
          this.$store.state.global.isLoadingShow = true;
          //上传结果
          this.$store.state.wenliganzhi.result = Math.floor(
            (this.$store.state.wenliganzhi.progressData[
              this.$store.state.wenliganzhi.progressData.length - 1
            ][0] +
              this.$store.state.wenliganzhi.progressData[
                this.$store.state.wenliganzhi.progressData.length - 2
              ][0] +
              this.$store.state.wenliganzhi.progressData[
                this.$store.state.wenliganzhi.progressData.length - 3
              ][0]) /
              3
          );
          await this.onSubmit();
          return;
        }
        this.pw = Math.floor((this.totalImgNum / 20) * 100);
        let str = "";
        str = this.imgLv1 > 9 ? this.imgLv1 : "0" + this.imgLv1;
        if (
          this.imgUrl ===
          "https://oss.uflycloud.com/ufly_ai_vpft/SelfTest/CS2nd/CS2nd_3_" +
            str +
            ".png"
        ) {
          this.showImg();
        } else {
          this.loadImgFunc();
          this.imgUrl =
            "https://oss.uflycloud.com/ufly_ai_vpft/SelfTest/CS2nd/CS2nd_3_" +
            str +
            ".png";
        }
      }
      if (this.$store.state.global.itemNum === 4) {
        //纹理运动辨别能力测试
        img.style.width = this.imgWidth * 4 + "px";
        if (this.isRotate) {
          img.style.left = -this.imgWidth * 3 + "px";
        } else {
          img.style.left = "0px";
        }
        //判断是否是测试状态
        if (this.$store.state.global.isTest) {
          if (this.imgUrl === "") {
            this.imgUrl =
              "https://oss.uflycloud.com/ufly_ai_vpft/SelfTest/MG2nd/MG2nd_2_3_00.png";
          } else {
            this.showImg();
          }
          return;
        }
        //判断是否结束
        if (this.totalImgNum > 20) {
          this.$store.state.global.isLoadingShow = true;
          //上传结果
          this.$store.state.wenliyundong.result = Math.floor(
            (this.$store.state.wenliyundong.progressData[
              this.$store.state.wenliyundong.progressData.length - 1
            ][0] +
              this.$store.state.wenliyundong.progressData[
                this.$store.state.wenliyundong.progressData.length - 2
              ][0] +
              this.$store.state.wenliyundong.progressData[
                this.$store.state.wenliyundong.progressData.length - 3
              ][0]) /
              3
          );
          await this.onSubmit();
          return;
        }
        this.pw = Math.floor((this.totalImgNum / 20) * 100);
        let str = "";
        str = this.imgLv1 > 9 ? this.imgLv1 : "0" + this.imgLv1;
        if (
          this.imgUrl ===
          "https://oss.uflycloud.com/ufly_ai_vpft/SelfTest/MG2nd/MG2nd_2_3_" +
            str +
            ".png"
        ) {
          this.showImg();
        } else {
          this.loadImgFunc();
          this.imgUrl =
            "https://oss.uflycloud.com/ufly_ai_vpft/SelfTest/MG2nd/MG2nd_2_3_" +
            str +
            ".png";
        }
      }
      if (this.$store.state.global.itemNum === 5) {
        //光栅运动辨别能力测试
        img.style.width = this.imgWidth * 4 + "px";
        if (this.isRotate) {
          img.style.left = -this.imgWidth * 3 + "px";
        } else {
          img.style.left = "0px";
        }
        //判断是否是测试状态
        if (this.$store.state.global.isTest) {
          if (this.imgUrl === "") {
            this.imgUrl =
              "https://oss.uflycloud.com/ufly_ai_vpft/SelfTest/MG1st/MG1st_2_3_00.png";
          } else {
            this.showImg();
          }
          return;
        }
        //判断是否结束
        if (this.totalImgNum > 20) {
          this.$store.state.global.isLoadingShow = true;
          //上传结果
          this.$store.state.guangshanyundong.result = Math.floor(
            (this.$store.state.guangshanyundong.progressData[
              this.$store.state.guangshanyundong.progressData.length - 1
            ][0] +
              this.$store.state.guangshanyundong.progressData[
                this.$store.state.guangshanyundong.progressData.length - 2
              ][0] +
              this.$store.state.guangshanyundong.progressData[
                this.$store.state.guangshanyundong.progressData.length - 3
              ][0]) /
              3
          );
          await this.onSubmit();
          return;
        }
        this.pw = Math.floor((this.totalImgNum / 20) * 100);
        let str = "";
        str = this.imgLv1 > 9 ? this.imgLv1 : "0" + this.imgLv1;
        if (
          this.imgUrl ===
          "https://oss.uflycloud.com/ufly_ai_vpft/SelfTest/MG1st/MG1st_2_3_" +
            str +
            ".png"
        ) {
          this.showImg();
        } else {
          this.loadImgFunc();
          this.imgUrl =
            "https://oss.uflycloud.com/ufly_ai_vpft/SelfTest/MG1st/MG1st_2_3_" +
            str +
            ".png";
        }
      }
      if (this.$store.state.global.itemNum === 6) {
        //噪音排除能力测试
        if (this.isRotate) {
          img.style.transform = "rotate(90deg)";
        } else {
          img.style.transform = "rotate(0deg)";
        }
        //判断是否是测试状态
        if (this.$store.state.global.isTest) {
          if (this.imgUrl === "") {
            this.imgUrl =
              "https://oss.uflycloud.com/ufly_ai_vpft/SelfTest/NCSF/NCSF_3_00.png";
          } else {
            this.showImg();
          }
          return;
        }
        //判断是否结束
        if (this.totalImgNum > 20) {
          this.$store.state.global.isLoadingShow = true;
          //上传结果
          this.$store.state.zaoyinpaichu.result = Math.floor(
            (this.$store.state.zaoyinpaichu.progressData[
              this.$store.state.zaoyinpaichu.progressData.length - 1
            ][0] +
              this.$store.state.zaoyinpaichu.progressData[
                this.$store.state.zaoyinpaichu.progressData.length - 2
              ][0] +
              this.$store.state.zaoyinpaichu.progressData[
                this.$store.state.zaoyinpaichu.progressData.length - 3
              ][0]) /
              3
          );
          await this.onSubmit();
          return;
        }
        this.pw = Math.floor((this.totalImgNum / 20) * 100);
        let str = "";
        str = this.imgLv1 > 9 ? this.imgLv1 : "0" + this.imgLv1;
        if (
          this.imgUrl ===
          "https://oss.uflycloud.com/ufly_ai_vpft/SelfTest/NCSF/NCSF_3_" +
            str +
            ".png"
        ) {
          this.showImg();
        } else {
          this.loadImgFunc();
          this.imgUrl =
            "https://oss.uflycloud.com/ufly_ai_vpft/SelfTest/NCSF/NCSF_3_" +
            str +
            ".png";
        }
      }
    },
    selectLeft() {
      if (!this.isAnwser) {
        return;
      }
      this.isAnwser = false;
      if (this.$store.state.global.itemNum === 0) {
        //光栅锐度能力测试
        if (this.isRotate) {
          //对
          this.onTip("correct");
          this.onPlayAudio(true);
          this.$store.state.guangshanruidu.progressData.push([
            this.imgLv1,
            true,
          ]);
          if (this.totalImgNum <= 4) {
            this.imgLv1 += 2;
          } else {
            this.imgLv1 += 1;
          }
          this.isCorrect = true;
        } else {
          //错
          this.onPlayAudio(false);
          this.onTip("error");
          this.$store.state.guangshanruidu.progressData.push([
            this.imgLv1,
            false,
          ]);
          if (this.totalImgNum <= 4) {
            this.imgLv1 -= 2;
          } else {
            this.imgLv1 -= 1;
          }
          this.isCorrect = false;
        }
        if (this.imgLv1 < 0) {
          this.imgLv1 = 0;
        } else if (this.imgLv1 > 19) {
          this.imgLv1 = 19;
        }
      } else if (this.$store.state.global.itemNum === 1) {
        //截止频率
        if (this.isRotate) {
          //对
          this.onTip("correct");
          this.onPlayAudio(true);
          this.$store.state.jiezhipinlv.progressData.push([
            this.imgLv1,
            this.imgLv2,
            true,
          ]);

          if (this.totalImgNum <= 5) {
            this.imgLv2 += 3;
          } else if (this.totalImgNum <= 10) {
            this.imgLv2 += 2;
          } else if (this.totalImgNum <= 20) {
            if (this.isCorrect) {
              this.imgLv2 += 2;
            } else {
              this.imgLv2 += 1;
            }
          }

          this.isCorrect = true;
        } else {
          //错
          this.onPlayAudio(false);
          this.onTip("error");
          this.$store.state.jiezhipinlv.progressData.push([
            this.imgLv1,
            this.imgLv2,
            false,
          ]);
          if (this.totalImgNum <= 5) {
            this.imgLv2 -= 3;
          } else if (this.totalImgNum <= 10) {
            this.imgLv2 -= 2;
          } else if (this.totalImgNum <= 20) {
            if (this.isCorrect) {
              this.imgLv2 -= 1;
            } else {
              this.imgLv2 -= 2;
            }
          }
          this.isCorrect = false;
        }
        if (this.imgLv2 < 0) {
          this.imgLv2 = 0;
        } else if (this.imgLv2 > 49) {
          this.imgLv2 = 19;
        }
      } else if (this.$store.state.global.itemNum === 2) {
        //游标锐度
        if (this.isRotate) {
          //对
          this.onTip("correct");
          this.onPlayAudio(true);
          if (this.totalImgNum <= 8) {
            this.$store.state.youbiaoruidu.progressData[0].push([
              this.imgLv1,
              this.imgLv2,
              true,
            ]);
          } else if (this.totalImgNum <= 16) {
            this.$store.state.youbiaoruidu.progressData[1].push([
              this.imgLv1,
              this.imgLv2,
              true,
            ]);
          } else if (this.totalImgNum <= 24) {
            this.$store.state.youbiaoruidu.progressData[2].push([
              this.imgLv1,
              this.imgLv2,
              true,
            ]);
          }
          this.imgLv2++;
          this.isCorrect = true;
        } else {
          //错
          this.onTip("error");
          this.onPlayAudio(false);
          if (this.totalImgNum <= 8) {
            this.$store.state.youbiaoruidu.progressData[0].push([
              this.imgLv1,
              this.imgLv2,
              false,
            ]);
          } else if (this.totalImgNum <= 16) {
            this.$store.state.youbiaoruidu.progressData[1].push([
              this.imgLv1,
              this.imgLv2,
              false,
            ]);
          } else if (this.totalImgNum <= 24) {
            this.$store.state.youbiaoruidu.progressData[2].push([
              this.imgLv1,
              this.imgLv2,
              false,
            ]);
          }
          this.imgLv2--;
          this.isCorrect = false;
        }
        if (this.imgLv2 < 0) {
          this.imgLv2 = 0;
        } else if (this.imgLv2 > 7) {
          this.imgLv2 = 7;
        }
      }
      if (this.$store.state.global.itemNum === 3) {
        //纹理感知能力测试
        if (this.isRotate) {
          //对
          this.onTip("correct");
          this.onPlayAudio(true);
          this.$store.state.wenliganzhi.progressData.push([this.imgLv1, true]);
          if (this.totalImgNum <= 5) {
            this.imgLv1 += 3;
          } else if (this.totalImgNum <= 10) {
            this.imgLv1 += 2;
          } else if (this.totalImgNum <= 20) {
            if (this.isCorrect) {
              this.imgLv1 += 2;
            } else {
              this.imgLv1 += 1;
            }
          }
          this.isCorrect = true;
        } else {
          //错
          this.onTip("error");
          this.onPlayAudio(false);
          this.$store.state.wenliganzhi.progressData.push([this.imgLv1, false]);
          if (this.totalImgNum <= 5) {
            this.imgLv1 -= 3;
          } else if (this.totalImgNum <= 10) {
            this.imgLv1 -= 2;
          } else if (this.totalImgNum <= 20) {
            if (this.isCorrect) {
              this.imgLv1 -= 1;
            } else {
              this.imgLv1 -= 2;
            }
          }
          this.isCorrect = false;
        }
        if (this.imgLv1 < 0) {
          this.imgLv1 = 0;
        } else if (this.imgLv1 > 49) {
          this.imgLv1 = 49;
        }
      }
      if (this.$store.state.global.itemNum === 4) {
        //纹理运动辨别能力测试
        if (this.isRotate) {
          //对
          this.onTip("correct");
          this.onPlayAudio(true);
          this.$store.state.wenliyundong.progressData.push([this.imgLv1, true]);
          if (this.totalImgNum <= 5) {
            this.imgLv1 += 3;
          } else if (this.totalImgNum <= 10) {
            this.imgLv1 += 2;
          } else if (this.totalImgNum <= 20) {
            if (this.isCorrect) {
              this.imgLv1 += 2;
            } else {
              this.imgLv1 += 1;
            }
          }
          this.isCorrect = true;
        } else {
          //错
          this.onTip("error");
          this.onPlayAudio(false);
          this.$store.state.wenliyundong.progressData.push([
            this.imgLv1,
            false,
          ]);
          if (this.totalImgNum <= 5) {
            this.imgLv1 -= 3;
          } else if (this.totalImgNum <= 10) {
            this.imgLv1 -= 2;
          } else if (this.totalImgNum <= 20) {
            if (this.isCorrect) {
              this.imgLv1 -= 1;
            } else {
              this.imgLv1 -= 2;
            }
          }
          this.isCorrect = false;
        }
        if (this.imgLv1 < 0) {
          this.imgLv1 = 0;
        } else if (this.imgLv1 > 49) {
          this.imgLv1 = 49;
        }
      }
      if (this.$store.state.global.itemNum === 5) {
        //光栅运动辨别能力测试
        if (this.isRotate) {
          //对
          this.onTip("correct");
          this.onPlayAudio(true);
          this.$store.state.guangshanyundong.progressData.push([
            this.imgLv1,
            true,
          ]);
          if (this.totalImgNum <= 5) {
            this.imgLv1 += 3;
          } else if (this.totalImgNum <= 10) {
            this.imgLv1 += 2;
          } else if (this.totalImgNum <= 20) {
            if (this.isCorrect) {
              this.imgLv1 += 2;
            } else {
              this.imgLv1 += 1;
            }
          }
          this.isCorrect = true;
        } else {
          //错
          this.onTip("error");
          this.onPlayAudio(false);
          this.$store.state.guangshanyundong.progressData.push([
            this.imgLv1,
            false,
          ]);
          if (this.totalImgNum <= 5) {
            this.imgLv1 -= 3;
          } else if (this.totalImgNum <= 10) {
            this.imgLv1 -= 2;
          } else if (this.totalImgNum <= 20) {
            if (this.isCorrect) {
              this.imgLv1 -= 1;
            } else {
              this.imgLv1 -= 2;
            }
          }
          this.isCorrect = false;
        }
        if (this.imgLv1 < 0) {
          this.imgLv1 = 0;
        } else if (this.imgLv1 > 49) {
          this.imgLv1 = 49;
        }
      }
      if (this.$store.state.global.itemNum === 6) {
        //噪音排除能力测试
        if (this.isRotate) {
          //对
          this.onTip("correct");
          this.onPlayAudio(true);
          this.$store.state.zaoyinpaichu.progressData.push([this.imgLv1, true]);
          if (this.totalImgNum <= 5) {
            this.imgLv1 += 3;
          } else if (this.totalImgNum <= 10) {
            this.imgLv1 += 2;
          } else if (this.totalImgNum <= 20) {
            if (this.isCorrect) {
              this.imgLv1 += 2;
            } else {
              this.imgLv1 += 1;
            }
          }
          this.isCorrect = true;
        } else {
          //错
          this.onTip("error");
          this.onPlayAudio(false);
          this.$store.state.zaoyinpaichu.progressData.push([
            this.imgLv1,
            false,
          ]);
          if (this.totalImgNum <= 5) {
            this.imgLv1 -= 3;
          } else if (this.totalImgNum <= 10) {
            this.imgLv1 -= 2;
          } else if (this.totalImgNum <= 20) {
            if (this.isCorrect) {
              this.imgLv1 -= 1;
            } else {
              this.imgLv1 -= 2;
            }
          }
          this.isCorrect = false;
        }
        if (this.imgLv1 < 0) {
          this.imgLv1 = 0;
        } else if (this.imgLv1 > 49) {
          this.imgLv1 = 49;
        }
      }
      setTimeout(() => {
        this.getImgName();
      }, 500);
    },
    selectRight() {
      if (!this.isAnwser) {
        return;
      }
      this.isAnwser = false;
      if (this.$store.state.global.itemNum === 0) {
        //光栅锐度能力测试
        if (this.isRotate) {
          //错
          this.onTip("error");
          this.onPlayAudio(false);
          this.$store.state.guangshanruidu.progressData.push([
            this.imgLv1,
            false,
          ]);
          if (this.totalImgNum <= 4) {
            this.imgLv1 -= 2;
          } else {
            this.imgLv1 -= 1;
          }
          this.isCorrect = false;
        } else {
          //对
          this.onTip("correct");
          this.onPlayAudio(true);
          this.$store.state.guangshanruidu.progressData.push([
            this.imgLv1,
            true,
          ]);
          if (this.totalImgNum <= 4) {
            this.imgLv1 += 2;
          } else {
            this.imgLv1 += 1;
          }
          this.isCorrect = true;
        }
        if (this.imgLv1 < 0) {
          this.imgLv1 = 0;
        } else if (this.imgLv1 > 19) {
          this.imgLv1 = 19;
        }
      } else if (this.$store.state.global.itemNum === 1) {
        //截止频率
        if (this.isRotate) {
          //错
          this.onTip("error");
          this.onPlayAudio(false);
          this.$store.state.jiezhipinlv.progressData.push([
            this.imgLv1,
            this.imgLv2,
            false,
          ]);
          if (this.totalImgNum <= 5) {
            this.imgLv2 -= 3;
          } else if (this.totalImgNum <= 10) {
            this.imgLv2 -= 2;
          } else if (this.totalImgNum <= 20) {
            if (this.isCorrect) {
              this.imgLv2 -= 1;
            } else {
              this.imgLv2 -= 2;
            }
          }
          this.isCorrect = false;
        } else {
          //对
          this.onTip("correct");
          this.onPlayAudio(true);
          this.$store.state.jiezhipinlv.progressData.push([
            this.imgLv1,
            this.imgLv2,
            true,
          ]);
          if (this.totalImgNum <= 5) {
            this.imgLv2 += 3;
          } else if (this.totalImgNum <= 10) {
            this.imgLv2 += 2;
          } else if (this.totalImgNum <= 20) {
            if (this.isCorrect) {
              this.imgLv2 += 2;
            } else {
              this.imgLv2 += 1;
            }
          }
          this.isCorrect = true;
        }
        if (this.imgLv2 < 0) {
          this.imgLv2 = 0;
        } else if (this.imgLv2 > 49) {
          this.imgLv2 = 19;
        }
      } else if (this.$store.state.global.itemNum === 2) {
        //游标锐度
        if (this.isRotate) {
          //错
          this.onTip("error");
          this.onPlayAudio(false);
          if (this.totalImgNum <= 8) {
            this.$store.state.youbiaoruidu.progressData[0].push([
              this.imgLv1,
              this.imgLv2,
              false,
            ]);
          } else if (this.totalImgNum <= 16) {
            this.$store.state.youbiaoruidu.progressData[1].push([
              this.imgLv1,
              this.imgLv2,
              false,
            ]);
          } else if (this.totalImgNum <= 24) {
            this.$store.state.youbiaoruidu.progressData[2].push([
              this.imgLv1,
              this.imgLv2,
              false,
            ]);
          }
          this.imgLv2--;
          this.isCorrect = false;
        } else {
          //对
          this.onTip("correct");
          this.onPlayAudio(true);
          if (this.totalImgNum <= 8) {
            this.$store.state.youbiaoruidu.progressData[0].push([
              this.imgLv1,
              this.imgLv2,
              true,
            ]);
          } else if (this.totalImgNum <= 16) {
            this.$store.state.youbiaoruidu.progressData[1].push([
              this.imgLv1,
              this.imgLv2,
              true,
            ]);
          } else if (this.totalImgNum <= 24) {
            this.$store.state.youbiaoruidu.progressData[2].push([
              this.imgLv1,
              this.imgLv2,
              true,
            ]);
          }
          this.imgLv2++;
          this.isCorrect = true;
        }
        if (this.imgLv2 < 0) {
          this.imgLv2 = 0;
        } else if (this.imgLv2 > 7) {
          this.imgLv2 = 7;
        }
      }
      if (this.$store.state.global.itemNum === 3) {
        //纹理感知能力测试
        if (this.isRotate) {
          //错
          this.onTip("error");
          this.onPlayAudio(false);
          this.$store.state.wenliganzhi.progressData.push([this.imgLv1, false]);
          if (this.totalImgNum <= 5) {
            this.imgLv1 -= 3;
          } else if (this.totalImgNum <= 10) {
            this.imgLv1 -= 2;
          } else if (this.totalImgNum <= 20) {
            if (this.isCorrect) {
              this.imgLv1 -= 1;
            } else {
              this.imgLv1 -= 2;
            }
          }
          this.isCorrect = false;
        } else {
          //对
          this.onTip("correct");
          this.onPlayAudio(true);
          this.$store.state.wenliganzhi.progressData.push([this.imgLv1, true]);
          if (this.totalImgNum <= 5) {
            this.imgLv1 += 3;
          } else if (this.totalImgNum <= 10) {
            this.imgLv1 += 2;
          } else if (this.totalImgNum <= 20) {
            if (this.isCorrect) {
              this.imgLv1 += 2;
            } else {
              this.imgLv1 += 1;
            }
          }
          this.isCorrect = true;
        }
        if (this.imgLv1 < 0) {
          this.imgLv1 = 0;
        } else if (this.imgLv1 > 49) {
          this.imgLv1 = 49;
        }
      }
      if (this.$store.state.global.itemNum === 4) {
        //纹理运动辨别能力测试
        if (this.isRotate) {
          //错
          this.onTip("error");
          this.onPlayAudio(false);
          this.$store.state.wenliyundong.progressData.push([
            this.imgLv1,
            false,
          ]);
          if (this.totalImgNum <= 5) {
            this.imgLv1 -= 3;
          } else if (this.totalImgNum <= 10) {
            this.imgLv1 -= 2;
          } else if (this.totalImgNum <= 20) {
            if (this.isCorrect) {
              this.imgLv1 -= 1;
            } else {
              this.imgLv1 -= 2;
            }
          }
          this.isCorrect = false;
        } else {
          //对
          this.onTip("correct");
          this.onPlayAudio(true);
          this.$store.state.wenliyundong.progressData.push([this.imgLv1, true]);
          if (this.totalImgNum <= 5) {
            this.imgLv1 += 3;
          } else if (this.totalImgNum <= 10) {
            this.imgLv1 += 2;
          } else if (this.totalImgNum <= 20) {
            if (this.isCorrect) {
              this.imgLv1 += 2;
            } else {
              this.imgLv1 += 1;
            }
          }
          this.isCorrect = true;
        }
        if (this.imgLv1 < 0) {
          this.imgLv1 = 0;
        } else if (this.imgLv1 > 49) {
          this.imgLv1 = 49;
        }
      }
      if (this.$store.state.global.itemNum === 5) {
        //光栅运动辨别能力测试
        if (this.isRotate) {
          //错
          this.onTip("error");
          this.onPlayAudio(false);
          this.$store.state.guangshanyundong.progressData.push([
            this.imgLv1,
            false,
          ]);
          if (this.totalImgNum <= 5) {
            this.imgLv1 -= 3;
          } else if (this.totalImgNum <= 10) {
            this.imgLv1 -= 2;
          } else if (this.totalImgNum <= 20) {
            if (this.isCorrect) {
              this.imgLv1 -= 1;
            } else {
              this.imgLv1 -= 2;
            }
          }
          this.isCorrect = false;
        } else {
          //对
          this.onTip("correct");
          this.onPlayAudio(true);
          this.$store.state.guangshanyundong.progressData.push([
            this.imgLv1,
            true,
          ]);
          if (this.totalImgNum <= 5) {
            this.imgLv1 += 3;
          } else if (this.totalImgNum <= 10) {
            this.imgLv1 += 2;
          } else if (this.totalImgNum <= 20) {
            if (this.isCorrect) {
              this.imgLv1 += 2;
            } else {
              this.imgLv1 += 1;
            }
          }
          this.isCorrect = true;
        }
        if (this.imgLv1 < 0) {
          this.imgLv1 = 0;
        } else if (this.imgLv1 > 49) {
          this.imgLv1 = 49;
        }
      }
      if (this.$store.state.global.itemNum === 6) {
        //噪音排除能力测试
        if (this.isRotate) {
          //错
          this.onTip("error");
          this.onPlayAudio(false);
          this.$store.state.zaoyinpaichu.progressData.push([
            this.imgLv1,
            false,
          ]);
          if (this.totalImgNum <= 5) {
            this.imgLv1 -= 3;
          } else if (this.totalImgNum <= 10) {
            this.imgLv1 -= 2;
          } else if (this.totalImgNum <= 20) {
            if (this.isCorrect) {
              this.imgLv1 -= 1;
            } else {
              this.imgLv1 -= 2;
            }
          }
          this.isCorrect = false;
        } else {
          //对
          this.onTip("correct");
          this.onPlayAudio(true);
          this.$store.state.zaoyinpaichu.progressData.push([this.imgLv1, true]);
          if (this.totalImgNum <= 5) {
            this.imgLv1 += 3;
          } else if (this.totalImgNum <= 10) {
            this.imgLv1 += 2;
          } else if (this.totalImgNum <= 20) {
            if (this.isCorrect) {
              this.imgLv1 += 2;
            } else {
              this.imgLv1 += 1;
            }
          }
          this.isCorrect = true;
        }
        if (this.imgLv1 < 0) {
          this.imgLv1 = 0;
        } else if (this.imgLv1 > 49) {
          this.imgLv1 = 49;
        }
      }
      setTimeout(() => {
        this.getImgName();
      }, 500);
    },
  },
  mounted() {
    this.$store.state.global.isTrans = true;
    this.title =
      this.$store.state.commonDescription.title[
        this.$store.state.global.itemNum
      ];
    this.btnLeftImg = require("../../assets/common/" +
      this.$store.state.commonDescription.btnLeftImg[
        this.$store.state.global.itemNum
      ]);
    this.btnRightImg = require("../../assets/common/" +
      this.$store.state.commonDescription.btnRightImg[
        this.$store.state.global.itemNum
      ]);
    this.btnLeftSpan =
      this.$store.state.commonDescription.btnLeftSpan[
        this.$store.state.global.itemNum
      ];
    this.btnRightSpan =
      this.$store.state.commonDescription.btnRightSpan[
        this.$store.state.global.itemNum
      ];
    this.imgWidth = 600 / window.devicePixelRatio;
    // document.getElementById("img").style.left="100px"
    document.getElementById("imgContainer").style.width = this.imgWidth + "px";
    document.getElementById("imgContainer").style.height = this.imgWidth + "px";
    document.getElementById("bgImg").style.width = this.imgWidth + 20 + "px";

    // this.imgUrl='https://oss.uflycloud.com/ufly_ai_vpft/SelfTest/GA/GA_8_19.png'
    if (this.$store.state.global.itemNum === 0) {
      //光栅锐度能力测试
      this.imgNum = 1;
      this.imgLv1 = 10;
      this.totalImgNum = 0;
      this.$store.state.guangshanruidu.progressData = [];
      this.getImgName();
    } else if (this.$store.state.global.itemNum === 1) {
      //截止频率能力测试
      this.imgNum = 1;
      this.imgLv1 = 3;
      this.imgLv2 = 15;
      this.totalImgNum = 0;
      this.$store.state.jiezhipinlv.progressData = [];
      this.$store.state.jiezhipinlv.result = [];
      this.getImgName();
    } else if (this.$store.state.global.itemNum === 2) {
      //游标锐度能力测试
      this.imgNum = 1;
      if (this.$store.state.guangshanruidu.result <= 12) {
        this.$store.state.youbiaoruidu.lvData = [0, 1, 2];
      } else if (this.$store.state.guangshanruidu.result < 18) {
        this.$store.state.youbiaoruidu.lvData = [1, 2, 3];
      } else if (this.$store.state.guangshanruidu.result >= 18) {
        this.$store.state.youbiaoruidu.lvData = [2, 3, 4];
      }
      this.imgLv1 = this.$store.state.youbiaoruidu.lvData[0];
      this.imgLv2 = 3;
      this.totalImgNum = 0;
      this.$store.state.youbiaoruidu.progressData = [[], [], []];
      this.$store.state.youbiaoruidu.result = [];
      this.getImgName();
    } else if (this.$store.state.global.itemNum === 3) {
      //纹理感知能力测试
      this.imgNum = 3;
      this.imgLv1 = 10;
      this.totalImgNum = 0;
      this.$store.state.wenliganzhi.progressData = [];
      this.$store.state.wenliganzhi.result = [];
      this.getImgName();
    } else if (this.$store.state.global.itemNum === 4) {
      //纹理运动辨别能力测试
      this.imgNum = 4;
      this.imgLv1 = 10;
      this.totalImgNum = 0;
      this.$store.state.wenliyundong.progressData = [];
      this.$store.state.wenliyundong.result = [];
      this.getImgName();
    } else if (this.$store.state.global.itemNum === 5) {
      //光栅运动辨别能力测试
      this.imgNum = 4;
      this.imgLv1 = 15;
      this.totalImgNum = 0;
      this.$store.state.guangshanyundong.progressData = [];
      this.$store.state.guangshanyundong.result = null;
      this.getImgName();
    } else if (this.$store.state.global.itemNum === 6) {
      //噪音排除能力测试
      this.imgNum = 1;
      this.imgLv1 = 10;
      this.totalImgNum = 0;
      this.$store.state.zaoyinpaichu.progressData = [];
      this.$store.state.zaoyinpaichu.result = null;
      this.getImgName();
    }
  },
};
</script>

<style scoped>
.container {
  background: rgb(191, 191, 191);
  position: absolute;
  height: 100vw;
  width: 100vh;
  transform-origin: left top;
  transform: rotate(90deg);
  left: 100vw;
}
p {
  text-align: center;
}
#titleTop {
  /* padding-top: 3vw; */
  margin-top: 3vw;
  font-size: 5vw;
  font-weight: bold;
}
#titleBottom {
  font-size: 5vw;
  font-weight: 200;
}
#progressContainer {
  width: 90vh;
  height: 2vw;
  background: rgb(216, 216, 216);
  border-radius: 2vw;
  margin-left: 4vh;
  margin-top: 3vw;
  position: relative;
}
#progressContent {
  height: 2vw;
  /* color: rgb(117, 44, 44); */
  border-radius: 2vw;
  text-align: center;
  /* width: 50%; */
  background-color: #80dbff;
}
#progressContainer p {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  padding-top: 0;
  font-size: 3vw;
}
#imgContainer {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  overflow: hidden;
}
#bgImg {
  width: 320px;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}
#imgContainer img:nth-child(1) {
  position: absolute;
  /* left:50%;
        top:50%;
        transform:translate(-50%,-50%); */
}
#btnContainer {
  position: absolute;
  width: 90vw;
  left: 50%;
  top: 80%;
  transform: translate(-50%, 0%);
  display: flex;
  flex-direction: row;
  justify-content: space-around;
}
#btnLeft {
  width: 40vw;
  position: relative;
}
#btnLeft div {
  width: 40vw;
  height: 12vw;
  background: rgb(41, 123, 255);
  border-radius: 6vw 0 0 6vw;
}
#btnLeft img {
  width: 12vw;
  position: absolute;
  top: 0;
  left: 0;
}
#btnLeft span {
  font-size: 6vw;
  position: absolute;
  top: 3vw;
  left: 50%;
  color: white;
}
#btnRight {
  width: 40vw;
  position: relative;
}
#btnRight div {
  width: 40vw;
  height: 12vw;
  background: rgb(41, 123, 255);
  border-radius: 0 6vw 6vw 0;
}
#btnRight img {
  width: 12vw;
  position: absolute;
  top: 0;
  right: 0;
}
#btnRight span {
  font-size: 6vw;
  position: absolute;
  top: 3vw;
  right: 50%;
  color: white;
}
#tipImg {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 10vw;
}
</style>
